import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  legalProfile: generateApiPath({ prefix: AuthLevel.AUTH, name: 'legal-profile' }),
}

export { paths }
